export enum InvoiceType {
  INCOME = 'INCOME',
  OUTCOME = 'OUTCOME'
}
